import React from 'react';
import { connect } from 'react-redux';
import OptimizationContainer from './optimization-container';
import {addUpstreamFooterSectionsT, createSectionT} from "../../../state/actions/shared/section";

const mapSectionIdsToSection = (ids, sections) => {
  if(!ids){
    return [];
  } else {
    return ids.map((ele) => {
      const section = sections[ele];
      return section;
    });
  }
}

const OptimizationRedux = (props) => {
  return (
    <OptimizationContainer {...props}/>
  );
};

const mapStateToProps = (state, ownProps) => {
  const {entityId:id} = ownProps;
  const itineraryEntities = state.itineraries.itinerary || {};
  const {sections, editor} = itineraryEntities;
  const currentItinerary = editor[id];
  const { title, footerSectionIds } = currentItinerary;
  return {
    itineraryEntities,
    id,
    title,
    footerSections: mapSectionIdsToSection(footerSectionIds, sections)
  }
};

const mapDispatchToProps = (dispatch, ownProps) => {
  const { entityId: id } = ownProps;
  return {
    onCreateSection: () => dispatch(createSectionT('itinerary', id, false, 'FOOTER')),
    onFooterSearch: (sections) => dispatch(addUpstreamFooterSectionsT('itinerary', id, sections)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(OptimizationRedux);
